module.exports = __webpack_public_path__ + "Proxima Nova Regular.98dc6d838eee92b0077f.ttf";


//////////////////
// WEBPACK FOOTER
// /home/runner/work/ucla-prrla/ucla-prrla/ucla-prrla/fonts/Proxima Nova Regular.ttf
// module id = ../../../../../fonts/Proxima Nova Regular.ttf
// module chunks = 2